import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Text, Tooltip } from '@dixa/lib-shared-habla';
import Color from 'color';
import { memo, useMemo } from 'react';
import { formatInstrumentNumber } from 'analytics/components/panels/utils/formatInstrumentNumber/formatInstrumentNumber';
import { resolveInstrumentColor } from 'analytics/components/panels/utils/theming/theming';
import { formatMillisecondsToDuration } from 'utils/formatting/dateTime';
import { formatLocalizedNumber } from 'utils/formatting/number';
import styles from './metricInstrument.module.scss';
export const MetricInstrument = memo(function MetricInstrument({ instrument, theme = 'light', }) {
    const { data, format, title, description, color } = instrument;
    const formattedData = useMemo(() => {
        if (data === null)
            return 'n.a.';
        return formatInstrumentNumber(data, format);
    }, [data, format]);
    const tooltipContent = useMemo(() => {
        if (data === null)
            return undefined;
        switch (format) {
            case 'duration':
                return formatMillisecondsToDuration(data);
            case 'count':
                return formatLocalizedNumber(data);
            default:
                return undefined;
        }
    }, [data, format]);
    const instrumentColor = color ? resolveInstrumentColor(color) : undefined;
    const textColor = theme === 'dark' ? 'white' : 'primary';
    const isAbbreviated = data !== null && tooltipContent !== formattedData;
    const isTooltipDisabled = !isAbbreviated || format === 'number' || format === 'percentage';
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "100" }, { children: [_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "100", title: title }, { children: [color && (_jsx(Box, { as: "span", className: styles.colorIndicator, style: {
                            background: instrumentColor,
                            boxShadow: theme === 'dark'
                                ? `0px 0px 0px 1px ${Color(instrumentColor).lighten(0.3)}`
                                : undefined,
                        } })), _jsx(Text.Paragraph, Object.assign({ variant: "4", color: textColor, subdued: true }, { children: title }))] })), _jsx(Tooltip, Object.assign({ content: tooltipContent, dark: true, disabled: isTooltipDisabled, wrap: "div", wrapProps: { className: styles.dataWrapper } }, { children: _jsx(Text.Heading, Object.assign({ variant: "heading-1", color: textColor, className: styles.dataText, as: "span" }, { children: formattedData })) })), description && (_jsx(Text.Paragraph, Object.assign({ variant: "4", color: theme === 'dark' ? 'white' : undefined, subdued: true }, { children: description })))] })));
});
